import imgs from "./../imgs/img_elements";

const content = {
  intro: {
    icon: imgs.intro.icon,
    bg: imgs.intro.bg,
    title: "Tu Aliado en Marketing Digital",
    text:
      "Enfocados en generar experiencias digitales, guiando a las marcas en su camino hacia la era digital.",
    btn: {
      type: window.screen.width <= 500 ? "adivor" : "purple",
      href: "#Servicios",
      text: "VER SERVICIOS"
    },
    form: {}
  },
  banner: {
    img: imgs.banner.img,
    title: "Tu empresa en la web",
    text: "Creamos páginas web para generar prospectos y aumentar tus ventas."
  },
  cta: {
    img: imgs.cta.img,
    text:
      "Desarrollamos las Herramientas que necesita tu empresa para entrar en el <span class='orange-text animated flash'>Mundo Digital</span>",
    btn: {
      type: window.screen.width <= 500 ? "adivor" : "purple",
      href: "#Contacto",
      text: "INICIA TU PROYECTO"
    }
  },
  servicios: {
    s1: {
      id: "servicios-s1",
      title: "Aplicación Móvil",
      description:
        "Herramientas que permiten elevar los índices de productividad y reducir los costos, ahorran tiempo, eficaces, automatiza las actividades operativas diarias.",
      icon: imgs.services.app
    },
    s2: {
      id: "servicios-s2",
      title: "Web",
      description:
        "Logramos que la experiencia física en tu establecimiento sea igual en tu sitio web, transmitimos confianza y comunicación eficiente con tus clientes.",
      icon: imgs.services.web
    },
    s3: {
      id: "servicios-s3",
      title: "Ecomerce",
      description:
        "Ofreces 21/7 tus productos o servicios, tienes capacidad analítica y predictiva en tiempo real.",
      icon: imgs.services.ecommerce
    },
    s4: {
      id: "servicios-s4",
      title: "Email Marketing",
      description:
        "Transmisión y entrega de mensajes claros de promoción y fidelización continua. Aumento en el valor de tu marca.",
      icon: imgs.services.email
    },
    s5: {
      id: "servicios-s5",
      title: "Redes Sociales y Estrategia de Comunicación",
      description:
        "Generación de contenido relevante para tu marca, aumento de visibilidad, posicionamiento e interacción con tu comunidad.",
      icon: imgs.services.redes
    },
    s6: {
      id: "servicios-s6",
      title: "Google ADS",
      description:
        "Todos los tipos de campaña (búsqueda como las de display, vídeo o aplicaciones) que te ayudan a llegar a más clientes cuando acuden a Google, sitios web y aplicaciones para encontrar información y ser más eficientes.",
      icon: imgs.services.googleads
    }
  },
  clientes: {
    bg: imgs.clients.bg,
    clients: {
      c1: {
        id: "c1",
        logo: imgs.clients.c1
      },
      c2: {
        id: "c2",
        logo: imgs.clients.c2
      },
      c3: {
        id: "c3",
        logo: imgs.clients.c3
      },
      c4: {
        id: "c4",
        logo: imgs.clients.c4
      },
      c5: {
        id: "c5",
        logo: imgs.clients.c5
      },
      c6: {
        id: "c6",
        logo: imgs.clients.c6
      },
      c7: {
        id: "c7",
        logo: imgs.clients.c7
      },
      c8: {
        id: "c8",
        logo: imgs.clients.c8
      }
    }
  },
  otrosservicios: {
    servicios: {
      os1: {
        id: "os1",
        icon: imgs.otros.os1.icon,
        bg: imgs.otros.os1.src,
        title: "Auditoría y Optimización SEO",
        description:
          "El SEO es el proceso de mejorar la visibilidad de un sitio web en los resultados orgánicos de los diferentes buscadores"
      },
      os2: {
        id: "os2",
        icon: imgs.otros.os2.icon,
        bg: imgs.otros.os2.src,
        title: "Branding",
        description:
          "Imagen representativa de su actividad y filosofía de trabajo"
      },
      os3: {
        id: "os3",
        icon: imgs.otros.os3.icon,
        bg: imgs.otros.os3.src,
        title: "Inbound Marketing",
        description:
          "La metodología inbound consiste en crear contenido diseñado específicamente para llamar la atención de clientes ideales, atraer prospectos y motivarlos a conocer cada vez más de la marca."
      },
      os4: {
        id: "os4",
        icon: imgs.otros.os4.icon,
        bg: imgs.otros.os4.src,
        title: "Comercio Electronico",
        description:
          "El desarrollamos su ​tienda en línea, optimizamos sus sistemas de pago ​y brindamos​ comodidad a sus compradores"
      }
    }
  },
  partners: {
    p1: {
      id: "p1",
      img: imgs.partners.p1
    },
    p2: {
      id: "p2",
      img: imgs.partners.p2
    },
    p3: {
      id: "p3",
      img: imgs.partners.p3
    }
  },
  testimonios: {},
  footer: {
    imgs: imgs.footer,
    description:
      "Somos ADIVOR, la agencia enfocada a generar experiencias digitales que garanticen resultados efectivos a través del trabajo creativo y estratégico de un equipo comprometido en guiar a las marcas en su camino hacia la era digital.",
    tel: "(222 232-0860)",
    mail: "puebla@adivor.com",
    address:
      "Avenida Juárez No.1310 Segundo Piso Int. 201 Col, Centro, Puebla, Puebla. CP. 72000"
  }
};

export default content;



// WEBPACK FOOTER //
// ./src/content/content.js